import { render, staticRenderFns } from "./3DEarth.vue?vue&type=template&id=b1bb7210&scoped=true&"
import script from "./3DEarth.vue?vue&type=script&lang=js&"
export * from "./3DEarth.vue?vue&type=script&lang=js&"
import style0 from "./3DEarth.vue?vue&type=style&index=0&id=b1bb7210&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1bb7210",
  null
  
)

export default component.exports